import { FileDropZoneTranslate } from './fileDropZone.model';

const fileDropZoneTranslateEN: FileDropZoneTranslate = {
  placeholder: 'Drag a file here or click to select',
  changeFile: 'Change file',
  dragRejected: 'File type not allowed',
  dropToReplace: 'Drop to replace the file',
  cancelLabel: 'Cancel upload',
  removeLabel: 'Remove file',
  errors: {
    invalidType: 'File type not allowed',
    tooLarge: 'File too large (max {{size}} MB)',
  },
};

export default fileDropZoneTranslateEN;
